<div class="container-fluid">
  <div class="card">
    <div class="card-header pb-0">
      <div class="media-space-between">
        <h4 *ngIf="releadRouters; else fsi">
          {{ "routers.relead.title" | translate }}
        </h4>
        <ng-template #fsi>
          <h4>{{ "routers.fsiRouters.title" | translate }}</h4>
        </ng-template>
        <div class="media-space-between">
          <form class="d-inline-flex m-r-10" [formGroup]="formFilter">
            <app-search-field
              [form]="formFilter | asFormGroup"
              [filterOptions]="filterRouter"
              [placeholder]="'placeholder.searchMac' | translate"
              inputFormControlName="MAC"
              (emitSelectedOptions)="saveOption($event)"
            ></app-search-field>
          </form>
          <button
            class="btn btn-primary"
            type="button"
            style="float: right"
            data-bs-toggle="modal"
            data-original-title="test"
            data-bs-target="#exampleModal"
            (click)="createRouter()"
          >
            <i class="icon-plus"></i>
            {{ "buttons.addRouter" | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="card-body">
      
        <app-list-routers></app-list-routers>
      
    </div>
  </div>
</div>
